import '@ckeditor/ckeditor5-build-classic/build/translations/es';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const Editor = ({ value, onChange, ...rest }) => {
  return (
    <CKEditor
      config={{
        language: 'es',
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
      }}
      {...rest}
      editor={ClassicEditor}
      data={value}
      onChange={(event, editor) => {
        onChange({ target: { value: editor.getData() } });
      }}
    />
  );
};

export default memo(Editor);

Editor.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func
};
